import { Component, OnInit } from "@angular/core";
import { MaintenanceUserService } from "../../core/services/maintenance-user.service";
import { ListValueService } from "src/app/core/services/list-value.service";

import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { RoutingConstants } from "src/app/constants/routingConstants";

import { merge, Observable, OperatorFunction, Subject } from "rxjs";
import { distinctUntilChanged, map } from "rxjs/operators";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { FiltersTableStateService } from "src/app/core/services/filters-table-state.service";

import { TokenService } from "src/app/core/services/token.service";
import { CommonService } from "src/app/core/services/common.service";
import { SweetAlertService } from "src/app/core/services/sweet-alert.service";
import { AppConstants } from "src/app/constants/app.constants";

@Component({
  selector: "app-mantener-usuario-selected",
  templateUrl: "./app.mantenerUsuario.usuarioSelected.html",
  styleUrls: ["./app.mantenerUsuario.usuarioSelected.scss"],
})
export class MantenerUsuarioSelectedComponent implements OnInit {
  public maintenanceUser;
  public operation: string;
  roles = AppConstants.roles;
  public routing = RoutingConstants.maintenanceUser;
  maxElements: number = AppConstants.maxElementsInputWithSearch;
  numPages: number = 0;
  numElements: number = 0;
  totalElements: number = 0;

  lists = {
    usConcesionarioList: [],
    usPerfilList: [],
  };

  selectedPerfil: "";
  usConfirmacion: undefined;
  idUrlParam: undefined;

  focus$ = new Subject<string>();
  focusPerfil$ = new Subject<string>();
  focusConcesionario$ = new Subject<string>();

  errorMessages = {
    usId: "Id no válido",
    usApellido1: "Apellido 1 no válido",
    usApellido2: "Apellido 2 no válido",
    usConcesionario: "Concesionario no válido",
    usEmail: "El Email no válido",
    // usIdioma: "Idioma no válido",
    usNombre: "Nombre no válido",
    usObservaciones: "Observaciones no válido",
    usPerfil: "Perfil no válido",
    usTelefono: "Teléfono no válido",
    usPwd: "Formato contraseña no válido",
    usConfirmacion: "Formato confirmación no válido",
  };

  fieldsToIgnoreEdit = ["usPwd", "usConfirmacion"];
  fieldsToIgnoreModDatPers = [
    "usConcesionario",
    "usObservaciones",
    "usPerfil",
    "usPwd",
    "usConfirmacion",
  ];

  searchConcesionario: OperatorFunction<string, readonly string[]> = (
    text$: Observable<string>
  ) => {
    const debouncedText$ = text$.pipe(distinctUntilChanged());
    const inputFocus$ = this.focus$;

    return merge(debouncedText$, inputFocus$).pipe(
      map((term) =>
        (term.length < 2
          ? this.lists.usConcesionarioList
          : this.lists.usConcesionarioList.filter(
              (v) =>
                v.coId.toLowerCase().indexOf(term.toLowerCase()) > -1 ||
                v.coNombre?.toLowerCase().indexOf(term.toLowerCase()) > -1
            )
        ).slice(0, this.maxElements)
      )
    );
  };

  searchPerfil: OperatorFunction<string, readonly string[]> = (
    text$: Observable<string>
  ) => {
    const debouncedText$ = text$.pipe(distinctUntilChanged());
    const inputFocus$ = this.focus$;

    return merge(debouncedText$, inputFocus$).pipe(
      map((term) =>
        (term.length < 2
          ? this.lists.usPerfilList
          : this.lists.usPerfilList.filter(
              (v) =>
                v.peId.toLowerCase().indexOf(term.toLowerCase()) > -1 ||
                v.peDesc?.toLowerCase().indexOf(term.toLowerCase()) > -1 ||
                (v.peId + " - " + v.peDesc).toLowerCase().indexOf(term.toLowerCase()) > -1
            )
        ).slice(0, this.maxElements)
      )
    );
  };

  public onFocus(e: Event): void {
    e.stopPropagation();
    setTimeout(() => {
      const inputEvent: Event = new Event("input");
      e.target.dispatchEvent(inputEvent);
    }, 0);
  }

  public onBlurPerfil(input): void {
    const usPerfil = this.maintenanceUser.value.usPerfil;
    console.log(usPerfil);
    if(typeof usPerfil == "string") {
      const perfiles = this.lists.usPerfilList.filter(
        (v) =>
          v.peId.toLowerCase().indexOf(usPerfil.toLowerCase()) > -1 ||
          v.peDesc?.toLowerCase().indexOf(usPerfil.toLowerCase()) > -1 ||
          (v.peId + " - " + v.peDesc).toLowerCase().indexOf(usPerfil.toLowerCase()) > -1
      )
      if(perfiles.length == 1) {
        const perfil = perfiles[0];
        this.maintenanceUser.controls.usPerfil.patchValue(perfil);
      } else {
        this.maintenanceUser.controls.usPerfil.patchValue(null);
      }
    }
  }

  formatterConcesionario = (x: { coId: string }) => {
    return x.coId;
  };
  
  formatterConcesionarioResults = (x: { coId: string }) => {
    return x.coId;
  };

  formatterPerfil = (x: { peId: string; peDesc: any }) => {
    if(x.peId == null) return "";
    if(x.peId != null && x.peDesc==null) return x.peId;
    if(x.peId != null && x.peDesc!=null && x.peDesc.peDesc==null) return x.peId + " - " + x.peDesc;
    return x.peId + " - " + x.peDesc.peDesc;
  }

  constructor(
    private listValueService: ListValueService,
    private maintenanceUserService: MaintenanceUserService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toastrAlertService: ToastrAlertService,
    private tokenService: TokenService,
    private commonService: CommonService,
    private sweetAlertService: SweetAlertService
  ) {}

  ngOnInit(): void {
    this.operation = this.activatedRoute.data["_value"]["operation"];
    this.initFormGroup();
    this.getConcessionaireList();
    this.getPerfilesList();

    if (this.operation === "edicion") {
      this.getUserInfo(this.activatedRoute.snapshot.params.id);
    } else if (this.operation === "mod-datos-pers") {
      if (this.tokenService.getUserName()) {
        this.getUserInfo(this.tokenService.getUserName());
      }
    }
  }

  initFormGroup() {
    const emailRegex =
      "[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?";

    if (this.hasRoleDisabledFields()) {
      this.initFormDisabled(emailRegex);
    } else if (this.operation === "mod-datos-pers") {
      this.initFormModPersonal(emailRegex);
    } else {
      this.maintenanceUser = new FormGroup({
        usId: new FormControl("", [
          Validators.required,
          Validators.maxLength(16),
        ]),
        usNombre: new FormControl("", [Validators.maxLength(64)]),
        usApellido1: new FormControl("", [Validators.maxLength(64)]),
        usApellido2: new FormControl("", [Validators.maxLength(64)]),
        usEmail: new FormControl("", [
          Validators.email,
          Validators.required,
          Validators.maxLength(128),
          Validators.pattern(emailRegex),
        ]),
        usTelefono: new FormControl("", [
          Validators.pattern("^[0-9]*$"),
          Validators.required,
          Validators.maxLength(32),
          Validators.minLength(9),
        ]),

        usObservaciones: new FormControl("", [Validators.maxLength(512)]),
        usCargo: new FormControl("", [Validators.maxLength(64)]),
        usConcesionario: new FormControl("", Validators.required),
        usPerfil: new FormControl("", Validators.required),
        usPagina: new FormControl(""),
        usReintentos: new FormControl(""),
        usIdioma: new FormControl(""),
        usActivo: new FormControl(true),
        usBloqueado: new FormControl(""),
      });
      if (this.operation == "creacion") {
        this.maintenanceUser.addControl(
          "usPwd",
          new FormControl("", [Validators.required, Validators.maxLength(255)])
        );
        this.maintenanceUser.addControl(
          "usConfirmacion",
          new FormControl("", [Validators.required, Validators.maxLength(255)])
        );
      }
    }
  }

  private hasRoleDisabledFields(): boolean {
    if (
      this.tokenService.hasRole(this.roles.CONCES) ||
      this.tokenService.hasRole(this.roles.ANALISTA) ||
      this.tokenService.hasRole(this.roles.ABASICO)
    ) {
      return true;
    }
    return false;
  }

  private initFormDisabled(emailRegex: string) {
    this.maintenanceUser = new FormGroup({
      usId: new FormControl({ value: "", disabled: true }, [
        Validators.required,
        Validators.maxLength(16),
      ]),
      usNombre: new FormControl({ value: "", disabled: true }, [
        Validators.maxLength(64),
      ]),
      usApellido1: new FormControl({ value: "", disabled: true }, [
        Validators.maxLength(64),
      ]),
      usApellido2: new FormControl({ value: "", disabled: true }, [
        Validators.maxLength(64),
      ]),
      usEmail: new FormControl({ value: "", disabled: true }, [
        Validators.email,
        Validators.required,
        Validators.maxLength(128),
        Validators.pattern(emailRegex),
      ]),
      usTelefono: new FormControl({ value: "", disabled: true }, [
        Validators.pattern("^[0-9]*$"),
        Validators.required,
        Validators.maxLength(32),
        Validators.minLength(9),
      ]),
      usObservaciones: new FormControl({ value: "", disabled: true }),
      usCargo: new FormControl({ value: "", disabled: true }),
      usConcesionario: new FormControl({ value: "", disabled: true }),
      usPerfil: new FormControl({ value: "", disabled: true }),
      usPagina: new FormControl({ value: "", disabled: true }),
      usReintentos: new FormControl({ value: "", disabled: true }),
      usIdioma: new FormControl({ value: "", disabled: true }),
      usActivo: new FormControl({ value: true, disabled: true }),
    });
  }

  private initFormModPersonal(emailRegex: string): void {
    this.maintenanceUser = new FormGroup({
      usId: new FormControl("", [
        Validators.required,
        Validators.maxLength(16),
      ]),
      usNombre: new FormControl("", [Validators.maxLength(64)]),
      usApellido1: new FormControl("", [Validators.maxLength(64)]),
      usApellido2: new FormControl("", [Validators.maxLength(64)]),
      usEmail: new FormControl("", [
        Validators.email,
        Validators.required,
        Validators.maxLength(128),
        Validators.pattern(emailRegex),
      ]),
      usTelefono: new FormControl("", [
        Validators.pattern("^[0-9]*$"),
        Validators.required,
        Validators.maxLength(32),
        Validators.minLength(9),
      ]),
      usObservaciones: new FormControl(""),
      usCargo: new FormControl(""),
      usConcesionario: new FormControl(""),
      usPerfil: new FormControl(""),
      usPagina: new FormControl(""),
      usReintentos: new FormControl(""),
      usIdioma: new FormControl(""),
      usActivo: new FormControl(true),
    });
  }

  onSave() {
    let invalidFields = this.commonService.findInvalidControls(
      this.maintenanceUser.controls
    );
    if (invalidFields.length > 0) {
      let text = this.commonService.getValueOfLabelsById(invalidFields);
      this.toastrAlertService.toastrFail(text);
    } else if (this.operation === "mod-datos-pers") {
      this.onEdit();
    } else {
      if (
        !(
          this.lists.usPerfilList.filter(
            (v) =>
              v.peId ==
              (this.maintenanceUser.value.usPerfil.peId
                ? this.maintenanceUser.value.usPerfil.peId
                : this.maintenanceUser.value.usPerfil
                ? this.maintenanceUser.value.usPerfil
                : undefined)
          ).length > 0
        )
      ) {
        this.toastrAlertService.toastrFail("Perfil no existe en la lista");
      } else if (
        !(
          this.lists.usConcesionarioList.filter(
            (v) =>
              v.coId ==
              (this.maintenanceUser.value.usConcesionario.coId
                ? this.maintenanceUser.value.usConcesionario.coId
                : this.maintenanceUser.value.usConcesionario
                ? this.maintenanceUser.value.usConcesionario
                : undefined)
          ).length > 0
        ) &&
        this.lists.usConcesionarioList.length > 0
      ) {
        this.toastrAlertService.toastrFail(
          "Concesionario no existe en la lista"
        );
      } else {
        if (this.operation === "edicion") {
          this.onEdit();
        } else {
          if (
            this.operation === "creacion" &&
            this.maintenanceUser.value.usPwd !==
              this.maintenanceUser.value.usConfirmacion
          ) {
            this.toastrAlertService.toastrFail(
              "Campo contraseña tiene que ser identico al campo confirmación"
            );
          } else {
            this.onCreate();
          }
        }
      }
    }
  }

  onEdit() {
    this.sweetAlertService.sweetAlertLoading();
    this.maintenanceUserService
      .editUser(this.createuserForSubmit(), this.maintenanceUser.value.usId)
      .subscribe(
        (data) => {
          this.toastrAlertService.toastrSuccess(
            data["mensaje"] ? data["mensaje"] : "Usuario editado"
          );
          if (this.operation === "mod-datos-pers") {
            this.goPredefinedMailBox();
          } else {
            this.router.navigate([this.routing.list]);
          }
          this.sweetAlertService.sweetAlertClose();
        },
        (err) => {
          this.toastrAlertService.toastrFail(
            err?.error?.mensaje
              ? err?.error?.mensaje
              : "Error al guardar usuario"
          );
          this.sweetAlertService.sweetAlertClose();
        }
      );
  }

  onCreate() {
    this.sweetAlertService.sweetAlertLoading();
    this.maintenanceUserService
      .createUser(this.createuserForSubmit())
      .subscribe(
        (data) => {
          this.toastrAlertService.toastrSuccess("Usuario creado");
          this.router.navigate([this.routing.list]);
          this.sweetAlertService.sweetAlertClose();
        },
        (err) => {
          this.toastrAlertService.toastrFail(
            err.error.mensaje ? err.error.mensaje : "Error al crear usuario"
          );
          this.sweetAlertService.sweetAlertClose();
        }
      );
  }

  getUserInfo(userId: string) {
    this.maintenanceUserService
      .getUsuario("?_identificador=" + userId)
      .subscribe(
        (data) => {
          this.setValues(data);
        },
        (err) => {
          this.toastrAlertService.toastrFail(
            err.error.mensaje ? err.error.mensaje : "Error al cargar usuario"
          );
        }
      );
  }

  setValues(data) {
    this.maintenanceUser.patchValue({
      usId: data["usId"],
      usNombre: data["usNombre"],
      usApellido1: data["usApellido1"],
      usApellido2: data["usApellido2"],
      usEmail: data["usEmail"],
      usTelefono: data["usTelefono"],
      usPwd: data["usPwd"],
      usConfirmacion: "",
      usCargo: data["usCargo"],
      usObservaciones: data["usObservaciones"],
      usPerfil: {
        peId: data["usPerfil"],
        peDesc: this.lists.usPerfilList.find((perfil) => {
          return perfil.peId === data["usPerfil"];
        }),
      },
      usConcesionario: {
        coId: data["usConcesionario"],
        coName: this.lists.usConcesionarioList.find((concesionario) => {
          return concesionario.coId === data["usConcesionario"];
        }),
      },
      usPagina: data["usPagina"],
      usReintentos: data["usReintentos"],
      usIdioma: {
        idId:
          data["idioma"] && data["idioma"]["idId"]
            ? data["idioma"]["idId"]
            : "es",
        idDescr:
          data["idioma"] && data["idioma"]["idDescr"]
            ? data["idioma"]["idDescr"]
            : "",
      },
      usActivo: data["usActivo"] == "Y" ? true : false,
      usBloqueado: data["usBloqueado"] == "Y" ? true : false,
    });
  }

  createuserForSubmit() {
    let dataFormUser = this.maintenanceUser.value;
    let returnUser: any = {
      usId: undefined,
      usApellido1: undefined,
      usApellido2: undefined,
      usCargo: undefined,
      usConcesionario: undefined,
      usEmail: undefined,
      usIdioma: undefined,
      usNombre: undefined,
      usObservaciones: undefined,
      usPerfil: undefined,
      usTelefono: undefined,
    };

    if (this.operation === "creacion") {
      returnUser.usPwd = undefined;
      returnUser.usConfirmacion = undefined;
    }

    returnUser.usId = dataFormUser.usId;
    returnUser.usNombre = dataFormUser.usNombre;
    returnUser.usApellido1 = dataFormUser.usApellido1;
    returnUser.usApellido2 = dataFormUser.usApellido2;
    returnUser.usEmail = dataFormUser.usEmail;
    returnUser.usTelefono = dataFormUser.usTelefono;

    returnUser.usCargo = dataFormUser.usCargo;
    returnUser.usConcesionario = dataFormUser.usConcesionario.coId
      ? dataFormUser.usConcesionario.coId
      : dataFormUser.usConcesionario;

    returnUser.usIdioma = dataFormUser.usIdioma.idId
      ? dataFormUser.usIdioma.idId
      : "es";

    returnUser.usObservaciones = dataFormUser.usObservaciones;
    returnUser.usPerfil = dataFormUser.usPerfil.peId
      ? dataFormUser.usPerfil.peId
      : dataFormUser.usPerfil
      ? dataFormUser.usPerfil
      : undefined;

    returnUser.usActivo = dataFormUser.usActivo ? "Y" : "N";
    returnUser.usBloqueado = dataFormUser.usBloqueado ? "Y" : "N";

    if (this.operation === "creacion") {
      returnUser.usPwd = dataFormUser.usPwd.normalize("NFKC");
      returnUser.usConfirmacion = dataFormUser.usConfirmacion;
    }

    return returnUser;
  }

  getConcessionaireList() {
    this.listValueService.listaConcesionariosActivos().subscribe(
      (data) => {
        this.lists.usConcesionarioList = data;
      },
      (err) => {
        this.toastrAlertService.toastrFail(
          err.error.mensaje
            ? err.error.mensaje
            : "Error al cargar lista concesionarios"
        );
      }
    );
  }

  getPerfilesList() {
    this.listValueService.listaPerfiles().subscribe(
      (data) => {
        this.lists.usPerfilList = data;
      },
      (err) => {
        this.toastrAlertService.toastrFail(
          err.error.mensaje
            ? err.error.mensaje
            : "Error al cargar lista perfiles"
        );
      }
    );
  }

  goList() {
    this.router.navigate([this.routing.list]);
  }
  goPredefinedMailBox() {
    this.tokenService.redirectPredefinedMailBox();
  }
}
